import {React, observer} from '@api'
import {BuilderCard, IGroupByQueryManagerResult, useGroupByRootStore} from '@modules'
import {Card, CardContent, CardHeader} from '@material-ui/core'

import * as css from './GroupSummaryCard.css'

export const GroupSummaryCard = observer<{group: IGroupByQueryManagerResult}>(({group}) => {
  //return <BuilderCard data={group} levelOfDetail={1} />

  const {count, id, key, title} = group,
    store = useGroupByRootStore(),
    {grouping, grouping: {toggleExpanded, def}, catalog: {cv: {visibleCardFields}}} = store

  return <Card className={css.root}
               onDoubleClick={() => toggleExpanded(id)}>
    <CardHeader className={css.cardHeader}
      title={
      <span className={css.titleAndCount}>
        <span className={css.title}>{title ?? id}</span>
        <span className={css.count}>({count})</span>
      </span>}
      subheader={def?.displayName?.singular ?? grouping.fullTitle}
    />
    {false && <CardContent>
      {visibleCardFields.map((v, i) => <div key={i} className={css.cardField}>{v.label ?? v.field}</div>)}
    </CardContent>}
  </Card>
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupSummaryCard.tsx